export const comments_4504525 = {"data":{"data":[],"links":{}}}